import {
  BUDGET_QUIZ_INTERFACE,
  DEFAULT_QUIZ_INTERFACE,
  CONDITIONAL_INPUT_QUIZ_INTERFACE,
} from "../../constants/quizInterfaces";
import {
  minimumOptionsSelected,
  isAnsweredWithBudget,
  isAnsweredWithInput,
} from "../../utils/quiz-selection-count";
import { allChildrenAnswered } from "../../utils/quiz-view-tracker";
import {
  BUDGET_QUESTION_ID,
  SELECTED_VEHICLE_CONFIRMATION_QUESTION_ID,
  TRADE_IN_QUESTION_ID,
  FEATURE_QUESTION_ID,
  MVB_UPDATE_PROFILE_PARENT_QUESTION_ID,
  PAYMENT_MODE_QUESTION_ID,
  CURRENT_CUSTOMER_VEHICLE_QUESTION_ID,
} from "../../constants/questionIds";
import { updatedProfileResponses } from "../../utils/quiz-response-controller";
import { submitUserUpdatedProfile } from "../../utils/quiz-submit-utils";
import { MAX_BUDGET_VALUES, MIN_BUDGET_VALUES } from "../budgetData";
import { createQuestionViewIndexMapping } from "../../utils/createQuestionViewIndexMapping";
import { FEATURE_MAPPING } from "./quizFeatureMapping";

export const MVBUpdateQuizQuestions = [
  {
    viewText: "Let's Confirm!",
    viewSubtext: "Car Matches will be Updated accordingly",
    isAnswered: allChildrenAnswered,
    visibilityCondition: function () {
      return true;
    },
    visitedOnce: false,
    header: "Update your profile",
    automaticForward: false,
    responses: updatedProfileResponses,
    submit: submitUserUpdatedProfile,
    questionViewId: MVB_UPDATE_PROFILE_PARENT_QUESTION_ID,
    children: [
      {
        text: "Is this the right vehicle and trim for you?",
        subtext: "",
        currSelected: [],
        selectionRange: { minimumSelection: 1, maximumSelection: 1 },
        quizInterface: DEFAULT_QUIZ_INTERFACE,
        optionCardsClassname: "two_cards quiz__options_cards",
        isAnswered: minimumOptionsSelected,
        childQuestionId: SELECTED_VEHICLE_CONFIRMATION_QUESTION_ID,
        prefill: function (response) {
          if (!response) return;
          this.options.forEach((option, i) => {
            option.selected = response.selectedOptions.includes(option.text);
            if (option.selected && !this.currSelected.includes(i)) {
              this.currSelected.push(i);
            }
          });
        },
        options: [
          { text: "Yes", selected: false },
          { text: "No", selected: false },
        ],
      },
      {
        text: "What colour do you prefer?",
        subtext: "",
        currSelected: [],
        selectionRange: { minimumSelection: 1, maximumSelection: 9 },
        quizInterface: DEFAULT_QUIZ_INTERFACE,
        optionCardsClassname: "four_cards quiz__options_cards",
        optionStyle: "feature-card",
        isAnswered: minimumOptionsSelected,
        childQuestionId: FEATURE_QUESTION_ID,
        prefill: function (response) {
          this.options.forEach((option, i) => {
            option.selected =
              response.selectedOptions?.[0]?.[option.featureKey];
            if (option.selected && !this.currSelected.includes(i)) {
              this.currSelected.push(i);
            }
          });
        },
        options: [
          JSON.parse(JSON.stringify(FEATURE_MAPPING["blackColor"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["whiteColor"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["greyColor"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["blueColor"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["redColor"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["greenColor"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["orangeColor"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["brownAndGoldColor"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["otherColor"])),
        ],
      },
      {
        text: "What are you currently driving?",
        subtext: "",
        currSelected: [],
        quizInterface: CONDITIONAL_INPUT_QUIZ_INTERFACE,
        optionCardsClassname: "three_cards quiz__options_cards",
        selectionRange: { minimumSelection: 0, maximumSelection: 0 },
        inputCondition: function () {
          return true;
        },
        inputLabel: "Vehicle (Year, Make, Model)",
        inputValue: "",
        prefill: function (response) {
          if (!response) return;
          this.inputValue = response.inputValue || "";
        },
        isAnswered: isAnsweredWithInput,
        childQuestionId: CURRENT_CUSTOMER_VEHICLE_QUESTION_ID,
        options: [],
      },
      {
        text: "Are you planning on keeping it?",
        subtext: "",
        currSelected: [],
        selectionRange: { minimumSelection: 1, maximumSelection: 1 },
        quizInterface: CONDITIONAL_INPUT_QUIZ_INTERFACE,
        optionCardsClassname: "three_cards quiz__options_cards",
        isAnswered: isAnsweredWithInput,
        childQuestionId: TRADE_IN_QUESTION_ID,
        inputCondition: function () {
          return (
            this[
              questionViewIndexMapping[MVB_UPDATE_PROFILE_PARENT_QUESTION_ID]
            ].children[3].options[1].selected === true
          );
        },
        inputLabel: "Notes (Kms, Current Payment, Payoff $, Lienholder)",
        inputValue: "",
        inputRequired: false,
        inputError: false,
        inputErrorMessage: "",
        checkInputError: function (text) {
          return !text;
        },
        prefill: function (response) {
          this.options.forEach((option, i) => {
            option.selected = response.selectedOptions.includes(option.text);
            if (option.selected && !this.currSelected.includes(i)) {
              this.currSelected.push(i);
            }
          });
          this.inputValue =
            this.options[1].selected === true ? response.inputValue : "";
        },
        options: [
          { text: "Yes", selected: false },
          { text: "No", selected: false },
          { text: "Haven’t decided", selected: false },
        ],
      },
      {
        text: "Are you interested in buying Cash, Financing, or Leasing?",
        subtext: "",
        currSelected: [],
        selectionRange: { minimumSelection: 1, maximumSelection: 3 },
        quizInterface: CONDITIONAL_INPUT_QUIZ_INTERFACE,
        optionCardsClassname: "three_cards quiz__options_cards",
        childQuestionId: PAYMENT_MODE_QUESTION_ID,
        isAnswered: isAnsweredWithInput,
        inputCondition: function () {
          return (
            this[
              questionViewIndexMapping[MVB_UPDATE_PROFILE_PARENT_QUESTION_ID]
            ].children[4].options[1].selected === true ||
            this[
              questionViewIndexMapping[MVB_UPDATE_PROFILE_PARENT_QUESTION_ID]
            ].children[4].options[2].selected === true
          );
        },
        inputLabel: "Downpayment",
        inputValue: "",
        inputRequired: true,
        inputErrorMessage: "Enter only Numeric Values",
        checkInputError: function (text) {
          return !text || isNaN(text);
        },
        prefill: function (response) {
          this.options.forEach((option, i) => {
            option.selected = response.selectedOptions.includes(option.text);
            if (option.selected && !this.currSelected.includes(i)) {
              this.currSelected.push(i);
            }
          });
          this.inputValue =
            this.options[1].selected === true ||
            this.options[2].selected === true
              ? response.inputValue
              : "";
        },
        inputError: false,
        options: [
          { text: "Cash", selected: false },
          { text: "Finance", selected: false },
          { text: "Lease", selected: false },
        ],
      },
      {
        text: "What’s your ideal budget?",
        subtext: "",
        currSelected: [],
        selectionRange: { minimumSelection: 1, maximumSelection: 1 },
        minBudget: "",
        maxBudget: "",
        monthlyBudget: "",
        quizInterface: BUDGET_QUIZ_INTERFACE,
        optionCardsClassname: "four_cards quiz__options_cards",
        isAnswered: isAnsweredWithBudget,
        childQuestionId: BUDGET_QUESTION_ID,

        prefill: function (response) {
          const budgetString = response.selectedOptions[0] || "";
          const budgetType = response.selectedOptions[1] || "";

          const [minBudget, maxBudget] = budgetString
            .split(" - ")
            .map((value) => parseInt(value.trim().replace(/[$,]/g, ""), 10));

          if (budgetType === "monthly") {
            this.monthlyBudget = budgetString;
          } else {
            this.maxBudget =
              MAX_BUDGET_VALUES.find(
                (val) => parseInt(val.replace(/[$,]/g, ""), 10) >= maxBudget
              ) || MAX_BUDGET_VALUES.at(-1);

            this.minBudget =
              MIN_BUDGET_VALUES.filter(
                (val) => parseInt(val.replace(/[$,]/g, ""), 10) <= minBudget
              ).at(-1) || MIN_BUDGET_VALUES.at(0);
          }
        },
      },
    ],
  },
];

const questionViewIndexMapping = createQuestionViewIndexMapping(
  MVBUpdateQuizQuestions
);
